import React from 'react'
import { Settings } from '@fielded/shared-ui/src/icons'

const settingsBreadcrumb = {
  title: 'Administration',
  icon: <Settings />
}

export default settingsBreadcrumb
